import raf from 'component-raf';
import scrollTop from 'scrolltop';
import event from 'dom-events'
import getPrefix from 'get-prefix'
import assignPolyfill from 'object.assign'


class Scroll {

    constructor(opt = {}) {

      this.rid = Math.round(Math.random()*10);

        this.options = {
            scrollEl: false,
            triggers: false,
            transformProperty: getPrefix('transform')
        };

        var assign = Object.assign || assignPolyfill;

        this.options = assign(this.options, opt);

        this.vars = {
            windowInnerHeight: false,
            documentOffsetHeight: false,
            current: false
        };

        this.state = {
          paused: false
        };

        this.initialize();
    }

    initialize() {

        this.rafId = false;

        this.bindAll();
        this.addEvents();

        // find initial scroll values
        this.run();
        // find initial bounding for current scroll
        this.cacheBoundings();
        // set initial state for current scroll
        this.scroll();

        // set first position
        this.prepareElements();
    }

    bindAll() {

        const methods = ['onResize', 'cacheBoundings', 'run', 'scroll'];
        methods.forEach((fn) => this[fn] = this[fn].bind(this));
    }

    addEvents() {

        event.on(window, 'resize', this.onResize);

        // TODO: find out why there's no scroll event on scrollEl in Firefox
        event.on(this.options.scrollEl || window, 'scroll', this.scroll);
    }

    cacheBoundings() {

        this.vars.windowInnerHeight = window.innerHeight;
        this.vars.documentOffsetHeight = document.documentElement.offsetHeight;

        if(this.options.triggers) {
            this.cacheTriggersBoundings();
        }
    }

    cacheTriggersBoundings() {

        this.vars.triggersCache = [];

        for (let index = 0; index < this.options.triggers.length; index++) {

            const el = this.options.triggers[index],
                scroll = this.vars.current.scrollY,
                bounding = el.getBoundingClientRect();

            const optionsAttr = el.getAttribute('data-trigger'),
                options = JSON.parse(optionsAttr);

            let bounds = {
                el: el,
                bounding: bounding,
                parentNode: el.parentNode,
                height: bounding.height,
                half: bounding.height *.5,
                top: bounding.top + scroll,
                bottom: bounding.bottom + scroll,
                options: options || false
            };

            bounds = this.extendCache(bounds);

            this.vars.triggersCache.push(bounds);
        }
    }

    extendCache(bounds) {
        return bounds;
    }

    prepareElements() {}

    run() {
        
        this.rafId = raf(this.run);

        this.update();
    }

    update() {

        if(this.options.scrollEl) {
          var scroll = this.options.scrollEl.scrollTop;
        } else {
          var scroll = scrollTop();
        }

        const e = {
            scrollY: scroll,
            deltaY: scroll - this.vars.current.scrollY
        };
        this.vars.current = e;
    }

    // api

    pause() {
      this.state.paused = true;
    }

    play() {
      this.state.paused = false;
    }

    // events

    scroll(e) {

        (typeof this.onScroll === 'function') && this.onScroll(this.vars.current);
    }

    onResize() {

        this.cacheBoundings();
    }

    destroy() {

        raf.cancel(this.rafId);
        event.off(window, 'resize', this.onResize);
        event.off(window, 'scroll', this.scroll);
    }
}

export default Scroll


// WEBPACK FOOTER //
// ./src/lib/scroll.js